import React from 'react';

export function GooglePlayStoreLogo() {
  return (
    <svg
      width="148"
      height="44"
      viewBox="0 0 148 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13536_276)">
        <path
          d="M142.312 43.8906H5.5787C2.57057 43.8906 0.109375 41.4279 0.109375 38.418V5.58217C0.109375 2.57222 2.57057 0.109531 5.5787 0.109531H142.312C145.32 0.109531 147.781 2.57222 147.781 5.58217V38.418C147.781 41.4279 145.32 43.8906 142.312 43.8906Z"
          fill="white"
        />
        <path
          d="M142.312 0.109531H5.5787C2.57057 0.109531 0.109375 2.57222 0.109375 5.58217V38.418C0.109375 41.4279 2.57057 43.8906 5.5787 43.8906H142.312C145.32 43.8906 147.781 41.4279 147.781 38.418V5.58217C147.781 2.57222 145.32 0.109531 142.312 0.109531ZM142.312 0.985153C144.845 0.985153 146.906 3.04768 146.906 5.58217V38.418C146.906 40.9529 144.845 43.0154 142.312 43.0154H5.5787C3.04575 43.0154 0.984467 40.9529 0.984467 38.418V5.58217C0.984467 3.04768 3.04575 0.985153 5.5787 0.985153H142.312Z"
          fill="black"
        />
        <path
          d="M51.9787 11.321C51.9787 12.238 51.7073 12.9683 51.1638 13.513C50.5464 14.1608 49.7418 14.4849 48.7526 14.4849C47.8053 14.4849 46.9999 14.1565 46.3375 13.4989C45.674 12.8418 45.3429 12.0269 45.3429 11.0546C45.3429 10.0819 45.674 9.26747 46.3375 8.60988C46.9999 7.95272 47.8053 7.62393 48.7526 7.62393C49.2226 7.62393 49.6726 7.71587 50.0999 7.89931C50.5272 8.08319 50.8699 8.32727 51.1263 8.63297L50.5494 9.21056C50.1149 8.69109 49.5166 8.43158 48.7526 8.43158C48.0617 8.43158 47.4643 8.67446 46.9602 9.16053C46.4559 9.64716 46.2039 10.2782 46.2039 11.0546C46.2039 11.8311 46.4559 12.4621 46.9602 12.9487C47.4643 13.4348 48.0617 13.6776 48.7526 13.6776C49.4855 13.6776 50.0965 13.4335 50.5857 12.9444C50.9032 12.6258 51.0869 12.183 51.136 11.6142H48.7526V10.8254H51.933C51.9637 10.9969 51.9787 11.1615 51.9787 11.321Z"
          fill="black"
        />
        <path
          d="M51.9787 11.3214H51.8693C51.8685 12.2175 51.6069 12.9135 51.0865 13.4361L51.0853 13.4369L51.0848 13.4378C50.487 14.0632 49.7187 14.3745 48.7526 14.3758C47.8306 14.3745 47.0589 14.0598 46.4145 13.4219C45.7715 12.7827 45.4535 12.0024 45.4523 11.055C45.4535 10.1072 45.7715 9.32731 46.4145 8.68855C47.0589 8.05022 47.8306 7.7351 48.7526 7.73379C49.2085 7.73379 49.6427 7.82278 50.0567 8.0002C50.4712 8.17893 50.7986 8.41316 51.0425 8.70398L51.1263 8.63338L51.0489 8.556L50.472 9.13402L50.5494 9.21097L50.6336 9.14091C50.1789 8.59573 49.5406 8.3209 48.7526 8.32254C48.0361 8.32166 47.4058 8.57778 46.8845 9.08236C46.3581 9.58858 46.0936 10.255 46.0945 11.055C46.0936 11.855 46.3581 12.5215 46.8845 13.0277C47.4058 13.5323 48.0361 13.7884 48.7526 13.7875C49.5098 13.7888 50.155 13.5318 50.663 13.0222C51.0023 12.6818 51.1946 12.2103 51.2451 11.6241L51.2553 11.5052H48.862V10.9353H51.933V10.8258L51.8253 10.8451C51.8552 11.011 51.8693 11.1687 51.8693 11.3214H51.9787H52.0881C52.0881 11.1551 52.0727 10.9841 52.0406 10.8062L52.0245 10.7164H48.6432V11.6147V11.7241H51.136V11.6147L51.0271 11.6052C50.9788 12.156 50.8036 12.5707 50.5084 12.8675C50.0383 13.336 49.4615 13.5673 48.7526 13.5686C48.0873 13.5677 47.5229 13.3385 47.0362 12.8704C46.5543 12.4039 46.3145 11.8084 46.3133 11.055C46.3145 10.3017 46.5543 9.70613 47.0362 9.23964C47.5229 8.77151 48.0873 8.54232 48.7526 8.54144C49.4923 8.54319 50.0508 8.78771 50.4657 9.28156L50.5426 9.37306L51.2036 8.71077L51.2745 8.63984L51.21 8.56322C50.9412 8.24264 50.5832 7.98816 50.143 7.79924C49.7021 7.60978 49.2367 7.51489 48.7526 7.51489C47.7801 7.51401 46.9409 7.85605 46.2602 8.53291C45.577 9.20845 45.2326 10.0576 45.2335 11.055C45.2326 12.052 45.577 12.9016 46.2607 13.5776C46.9409 14.254 47.7801 14.5956 48.7526 14.5947C49.7653 14.5956 50.6054 14.259 51.2429 13.5891L51.1638 13.5134L51.2411 13.5908C51.8078 13.0243 52.0889 12.259 52.0881 11.3214H51.9787Z"
          fill="black"
        />
        <path
          d="M57.0207 8.57799H54.0318V10.6602H56.7272V11.4494H54.0318V13.5316H57.0207V14.3384H53.1892V7.77121H57.0207V8.57799Z"
          fill="black"
        />
        <path
          d="M57.0206 8.57791V8.46846H53.9224V10.7696H56.6178V11.3395L53.9224 11.3398V13.641H56.9113V14.2288H53.2985V7.88059H56.9113V8.57791H57.0206V8.46846V8.57791H57.13V7.77114V7.66168H53.0798V14.4478H57.13V13.5315V13.4221H54.1412V11.5588H56.8365V10.6601V10.5507H54.1412V8.68737H57.13V8.57791H57.0206Z"
          fill="black"
        />
        <path
          d="M60.577 14.3384H59.7331V8.57799H57.9V7.77121H62.4101V8.57799H60.577V14.3384Z"
          fill="black"
        />
        <path
          d="M60.577 14.3383V14.2288H59.8425V8.46846H58.0094V7.88059H62.3008V8.46846H60.4677V14.3383H60.577V14.2288V14.3383H60.6864V8.68737H62.5195V7.77114V7.66168H57.7906V8.57791V8.68737H59.6237V14.4478H60.577H60.6864V14.3383H60.577Z"
          fill="black"
        />
        <path
          d="M65.6734 14.3384V7.77121H66.5164V14.3384H65.6734Z"
          fill="black"
        />
        <path
          d="M65.6734 14.3383H65.7827V7.88059H66.407V14.2288H65.6734V14.3383H65.7827H65.6734V14.4478H66.5164H66.6258V7.66168H65.6734H65.564V14.4478H65.6734V14.3383Z"
          fill="black"
        />
        <path
          d="M70.2573 14.3384H69.4134V8.57799H67.5804V7.77121H72.0905V8.57799H70.2573V14.3384Z"
          fill="black"
        />
        <path
          d="M70.2573 14.3383V14.2288H69.5228V8.46846H67.6898V7.88059H71.981V8.46846H70.1479V14.3383H70.2573V14.2288V14.3383H70.3667V8.68737H72.1998V7.77114V7.66168H67.471V8.57791V8.68737H69.304V14.4478H70.2573H70.3667V14.3383H70.2573Z"
          fill="black"
        />
        <path
          d="M76.4386 12.9397C76.9243 13.4318 77.5187 13.6776 78.2217 13.6776C78.9246 13.6776 79.5193 13.4318 80.0043 12.9397C80.4906 12.4476 80.7342 11.8186 80.7342 11.0546C80.7342 10.2906 80.4906 9.66161 80.0043 9.16951C79.5193 8.67741 78.9246 8.43158 78.2217 8.43158C77.5187 8.43158 76.9243 8.67741 76.4386 9.16951C75.9535 9.66161 75.71 10.2906 75.71 11.0546C75.71 11.8186 75.9535 12.4476 76.4386 12.9397ZM80.6282 13.4895C79.9829 14.1534 79.1804 14.4849 78.2217 14.4849C77.2619 14.4849 76.4599 14.1534 75.816 13.4895C75.1703 12.8263 74.8491 12.0145 74.8491 11.0546C74.8491 10.0947 75.1703 9.28279 75.816 8.61973C76.4599 7.95568 77.2619 7.62393 78.2217 7.62393C79.1754 7.62393 79.9757 7.95743 80.6239 8.624C81.2712 9.29056 81.5951 10.1007 81.5951 11.0546C81.5951 12.0145 81.272 12.8263 80.6282 13.4895Z"
          fill="black"
        />
        <path
          d="M76.4385 12.9401L76.3607 13.0171C76.8646 13.5289 77.4931 13.7888 78.2216 13.7875C78.9497 13.7888 79.5791 13.5289 80.0821 13.0171C80.5892 12.5048 80.8443 11.8421 80.8435 11.055C80.8443 10.2679 80.5892 9.60521 80.0821 9.09297C79.5791 8.58117 78.9497 8.32122 78.2216 8.32254C77.4931 8.32122 76.8646 8.58117 76.3607 9.09297C75.8548 9.60521 75.5993 10.2679 75.6006 11.055C75.5993 11.8421 75.8548 12.5048 76.3607 13.0171L76.4385 12.9401L76.5163 12.8632C76.0523 12.3907 75.8203 11.7963 75.8194 11.055C75.8203 10.3137 76.0523 9.71937 76.5163 9.24687C76.9846 8.77447 77.5439 8.54276 78.2216 8.54144C78.8988 8.54276 79.4594 8.77447 79.9265 9.24687C80.3914 9.71937 80.6234 10.3137 80.6243 11.055C80.6234 11.7963 80.3914 12.3907 79.9265 12.8632C79.4594 13.3356 78.8988 13.5673 78.2216 13.5686C77.5439 13.5673 76.9846 13.3356 76.5163 12.8632L76.4385 12.9401ZM80.6281 13.4899L80.5499 13.4138C79.9227 14.0569 79.1557 14.3745 78.2216 14.3758C77.2871 14.3745 76.5201 14.0569 75.8941 13.4138L75.8911 13.4104L75.8941 13.4138C75.2682 12.7686 74.9593 11.9905 74.9584 11.055C74.9593 10.1195 75.2682 9.34143 75.8941 8.69621C76.5201 8.05317 77.2871 7.7351 78.2216 7.73379C79.1497 7.7351 79.9149 8.05449 80.5457 8.70091C81.1738 9.34909 81.4844 10.126 81.4857 11.055C81.4844 11.9905 81.1746 12.7686 80.5499 13.4138L80.6281 13.4899L80.7068 13.566C81.3699 12.8845 81.7053 12.0392 81.7045 11.055C81.7053 10.0764 81.3686 9.23285 80.7024 8.54834C80.0359 7.86119 79.201 7.51368 78.2216 7.51488C77.2371 7.51368 76.3997 7.85955 75.7373 8.54407V8.54363C75.0729 9.22552 74.7388 10.0708 74.7396 11.055C74.7388 12.0392 75.0729 12.8845 75.7373 13.5664L75.7403 13.5695L75.7373 13.566C76.3997 14.2505 77.2371 14.5956 78.2216 14.5947C79.2057 14.5956 80.0431 14.2505 80.7068 13.566L80.6281 13.4899Z"
          fill="black"
        />
        <path
          d="M82.7787 14.3384V7.77121H83.8051L86.9948 12.88H87.0311L86.9948 11.6144V7.77121H87.8387V14.3384H86.9585L83.6213 8.98198H83.585L83.6213 10.248V14.3384H82.7787Z"
          fill="black"
        />
        <path
          d="M82.7787 14.3383H82.8881V7.88059H83.7444L86.9341 12.9894H87.0311H87.1434L87.1042 11.6127V7.88059H87.7293V14.2288H87.0192L83.682 8.87245H83.585H83.4726L83.5119 10.2497V14.2288H82.7787V14.3383H82.8881H82.7787V14.4478H83.6213H83.7307V10.2462L83.6944 8.97895L83.585 8.9819V9.09136H83.6213V8.9819L83.5285 9.04013L86.8977 14.4478H87.8387H87.9481V7.66168H86.9948H86.8854V11.6157L86.9217 12.8829L87.0311 12.88V12.7705H86.9948V12.88L87.0875 12.8218L83.8657 7.66168H82.7787H82.6693V14.4478H82.7787V14.3383Z"
          fill="black"
        />
        <path
          d="M117.083 32.9452H119.124V19.2623H117.083V32.9452ZM135.468 24.1912L133.128 30.1234H133.058L130.629 24.1912H128.431L132.072 32.4826L129.996 37.0946H132.126L137.737 24.1912H135.468ZM123.892 31.3911C123.223 31.3911 122.291 31.0567 122.291 30.229C122.291 29.1729 123.453 28.7681 124.455 28.7681C125.353 28.7681 125.774 28.9617 126.32 29.226C126.161 30.4933 125.07 31.3911 123.892 31.3911ZM124.138 23.8918C122.661 23.8918 121.13 24.5434 120.497 25.9869L122.308 26.7436C122.696 25.9869 123.416 25.7402 124.173 25.7402C125.229 25.7402 126.302 26.3742 126.32 27.5008V27.6415C125.95 27.4302 125.159 27.1135 124.191 27.1135C122.238 27.1135 120.25 28.187 120.25 30.1939C120.25 32.0247 121.851 33.2043 123.645 33.2043C125.018 33.2043 125.774 32.5882 126.25 31.8666H126.32V32.9226H128.29V27.6765C128.29 25.2476 126.478 23.8918 124.138 23.8918ZM111.524 25.8569H108.621V21.1667H111.524C113.05 21.1667 113.916 22.4309 113.916 23.5117C113.916 24.5721 113.05 25.8569 111.524 25.8569ZM111.471 19.2623H106.581V32.9452H108.621V27.7612H111.471C113.734 27.7612 115.957 26.1224 115.957 23.5117C115.957 20.9012 113.734 19.2623 111.471 19.2623ZM84.8019 31.3936C83.3918 31.3936 82.2112 30.2123 82.2112 28.5898C82.2112 26.9502 83.3918 25.7509 84.8019 25.7509C86.1941 25.7509 87.2867 26.9502 87.2867 28.5898C87.2867 30.2123 86.1941 31.3936 84.8019 31.3936ZM87.1457 24.9574H87.0751C86.6171 24.4109 85.7355 23.9171 84.6255 23.9171C82.2993 23.9171 80.1671 25.9625 80.1671 28.5898C80.1671 31.1996 82.2993 33.2274 84.6255 33.2274C85.7355 33.2274 86.6171 32.7335 87.0751 32.1696H87.1457V32.8396C87.1457 34.6208 86.1941 35.573 84.6609 35.573C83.4098 35.573 82.6343 34.6734 82.3168 33.9153L80.5372 34.6559C81.0482 35.8902 82.4053 37.4067 84.6609 37.4067C87.0576 37.4067 89.0842 35.9958 89.0842 32.5574V24.1993H87.1457V24.9574ZM90.4939 32.9452H92.5381V19.2619H90.4939V32.9452ZM95.5517 28.4312C95.4987 26.6324 96.9438 25.7158 97.9835 25.7158C98.7947 25.7158 99.4816 26.1211 99.7102 26.7035L95.5517 28.4312ZM101.896 26.8796C101.509 25.8389 100.327 23.9171 97.9129 23.9171C95.5162 23.9171 93.5251 25.8039 93.5251 28.5723C93.5251 31.1821 95.4987 33.2274 98.142 33.2274C100.275 33.2274 101.509 31.9225 102.019 31.1644L100.433 30.1062C99.9049 30.8823 99.1819 31.3936 98.142 31.3936C97.1023 31.3936 96.3623 30.9174 95.8863 29.9831L102.107 27.4085L101.896 26.8796ZM52.3347 25.3455V27.3203H57.0575C56.9165 28.4312 56.5464 29.2422 55.9824 29.8066C55.2953 30.4945 54.2203 31.2525 52.3347 31.2525C49.4269 31.2525 47.1537 28.9074 47.1537 25.9979C47.1537 23.0885 49.4269 20.743 52.3347 20.743C53.9032 20.743 55.0483 21.3603 55.8943 22.1538L57.2865 20.7609C56.1059 19.6322 54.5373 18.7681 52.3347 18.7681C48.3518 18.7681 45.0036 22.0128 45.0036 25.9979C45.0036 29.9831 48.3518 33.2274 52.3347 33.2274C54.4848 33.2274 56.1059 32.5224 57.3746 31.1996C58.6787 29.8947 59.0842 28.0609 59.0842 26.5799C59.0842 26.1211 59.0491 25.6983 58.9782 25.3455H52.3347ZM64.4535 31.3936C63.0434 31.3936 61.8274 30.2298 61.8274 28.5723C61.8274 26.8971 63.0434 25.7509 64.4535 25.7509C65.8631 25.7509 67.0791 26.8971 67.0791 28.5723C67.0791 30.2298 65.8631 31.3936 64.4535 31.3936ZM64.4535 23.9171C61.8803 23.9171 59.7831 25.8744 59.7831 28.5723C59.7831 31.2525 61.8803 33.2274 64.4535 33.2274C67.0262 33.2274 69.1233 31.2525 69.1233 28.5723C69.1233 25.8744 67.0262 23.9171 64.4535 23.9171ZM74.6409 31.3936C73.2314 31.3936 72.0152 30.2298 72.0152 28.5723C72.0152 26.8971 73.2314 25.7509 74.6409 25.7509C76.0506 25.7509 77.2666 26.8971 77.2666 28.5723C77.2666 30.2298 76.0506 31.3936 74.6409 31.3936ZM74.6409 23.9171C72.0678 23.9171 69.9711 25.8744 69.9711 28.5723C69.9711 31.2525 72.0678 33.2274 74.6409 33.2274C77.2137 33.2274 79.3108 31.2525 79.3108 28.5723C79.3108 25.8744 77.2137 23.9171 74.6409 23.9171Z"
          fill="black"
        />
        <path
          d="M11.6057 35.5605L11.5244 35.4827C11.2061 35.1457 11.0182 34.6224 11.0182 33.9448V34.1043V9.89771C11.0182 9.89552 11.0182 9.89388 11.0182 9.89213C11.0182 9.89421 11.0182 9.89596 11.0182 9.89815V10.0581C11.0182 9.32429 11.2373 8.77155 11.6044 8.44013L25.1572 22.0008L11.6057 35.5605ZM11.0182 9.89082C11.0182 9.83051 11.0198 9.77195 11.0229 9.71427C11.0198 9.77151 11.0182 9.83051 11.0182 9.89082ZM11.0229 9.71165C11.0229 9.71088 11.0229 9.71 11.0232 9.70913C11.0229 9.71 11.0229 9.71088 11.0229 9.71165ZM11.0232 9.70398C11.0232 9.70354 11.0232 9.70311 11.0232 9.70267C11.0232 9.70311 11.0232 9.70354 11.0232 9.70398Z"
          fill="url(#paint0_linear_13536_276)"
        />
        <path
          d="M29.6741 26.6831L29.7771 26.6245L35.1293 23.5817C35.6396 23.2914 35.9797 22.9395 36.1493 22.5671C35.9801 22.9395 35.6399 23.2918 35.1293 23.5821L29.7771 26.625L29.6741 26.6831ZM29.6754 26.5228L25.1572 22.001L29.6749 17.4801L35.1293 20.5807C35.8219 20.9745 36.2108 21.482 36.2758 22.0006C36.2758 22.001 36.2758 22.0019 36.2758 22.0027C36.2108 22.5201 35.8219 23.028 35.1293 23.4217L29.6754 26.5228Z"
          fill="url(#paint1_linear_13536_276)"
        />
        <path
          d="M12.5718 36.0771C12.1932 36.0771 11.8629 35.954 11.6053 35.7214L11.6057 35.721C11.8633 35.9536 12.1941 36.0771 12.5727 36.0771C12.6055 36.0771 12.6389 36.0763 12.6727 36.0746C12.6384 36.0763 12.6046 36.0771 12.5718 36.0771ZM12.5722 35.9168C12.1936 35.9172 11.8633 35.7937 11.6057 35.5611V35.5608L25.1572 22.001L29.6754 26.5227L13.7977 35.5496C13.3584 35.7988 12.9422 35.9168 12.5722 35.9168ZM11.6019 35.7185C11.5779 35.6967 11.5544 35.6736 11.5313 35.6496L11.6019 35.7185Z"
          fill="url(#paint2_linear_13536_276)"
        />
        <path
          d="M25.1571 22.001L11.6044 8.44033C11.862 8.20818 12.1919 8.08505 12.57 8.08505C12.941 8.08505 13.3575 8.20348 13.7977 8.45314L29.6749 17.48L25.1571 22.001ZM29.7771 17.3779L13.7977 8.29334C13.3575 8.04356 12.941 7.92514 12.57 7.92514C12.5683 7.92514 12.5671 7.92514 12.5653 7.92514C12.5675 7.92514 12.5692 7.92514 12.5718 7.92514C12.9418 7.92514 13.3579 8.04313 13.7977 8.2929L29.7771 17.3779Z"
          fill="url(#paint3_linear_13536_276)"
        />
        <path
          d="M12.6726 36.0747C13.0166 36.055 13.3973 35.9366 13.7977 35.7096L29.674 26.6831L13.7977 35.7096C13.3977 35.937 13.0166 36.055 12.6726 36.0747ZM11.6053 35.7215L11.6019 35.7185C11.6031 35.7194 11.6044 35.7206 11.6053 35.7215ZM11.5313 35.6497L11.5244 35.6429V35.6425C11.527 35.645 11.5291 35.6475 11.5313 35.6497Z"
          fill="white"
        />
        <path
          d="M29.674 26.6831L29.7771 26.6246L29.674 26.6831Z"
          fill="url(#paint4_linear_13536_276)"
        />
        <path
          d="M12.5727 36.0771C12.1941 36.0771 11.8633 35.9536 11.6057 35.721L11.6053 35.7214C11.6044 35.7206 11.6031 35.7193 11.6019 35.7185L11.5313 35.6496C11.5291 35.6474 11.527 35.6449 11.5244 35.6424L11.6057 35.5611C11.8633 35.7937 12.1936 35.9172 12.5722 35.9168C12.9422 35.9168 13.3584 35.7988 13.7977 35.5496L29.6754 26.5227L29.7771 26.6245L29.6741 26.683L13.7977 35.7095C13.3973 35.9365 13.0166 36.0549 12.6726 36.0746C12.6388 36.0763 12.6055 36.0771 12.5727 36.0771Z"
          fill="url(#paint5_linear_13536_276)"
        />
        <path
          d="M11.5244 35.6426C11.2061 35.3056 11.0182 34.7823 11.0182 34.1047V34.1042C11.0182 34.7823 11.2061 35.3051 11.5244 35.6421V35.6426Z"
          fill="white"
        />
        <path
          d="M11.5244 35.6426C11.2061 35.3056 11.0182 34.7827 11.0182 34.1047V33.9452C11.0182 34.6228 11.2061 35.1461 11.5244 35.4831L11.6057 35.5609L11.5244 35.6426Z"
          fill="url(#paint6_linear_13536_276)"
        />
        <path
          d="M11.5244 35.6426L11.6057 35.5609V35.5613L11.5244 35.6426Z"
          fill="url(#paint7_linear_13536_276)"
        />
        <path
          d="M36.1493 22.5669C36.2334 22.3821 36.2757 22.1923 36.2757 22.0024C36.2757 22.0021 36.2757 22.0017 36.2757 22.0017C36.2757 22.1919 36.2334 22.3817 36.1493 22.5669Z"
          fill="white"
        />
        <path
          d="M29.7771 26.6245L29.6754 26.5227L35.1293 23.4217C35.8219 23.028 36.2108 22.52 36.2757 22.0026C36.2757 22.1925 36.2334 22.3823 36.1493 22.5671C35.9796 22.9395 35.6395 23.2913 35.1293 23.5816L29.7771 26.6245Z"
          fill="url(#paint8_linear_13536_276)"
        />
        <path
          d="M36.2758 22.001V22.0005C36.2753 21.428 35.8929 20.8556 35.1293 20.4211L29.7771 17.3782H29.7767L29.7771 17.3779L35.1293 20.4207C35.8938 20.8551 36.2766 21.4284 36.2758 22.001Z"
          fill="#404040"
        />
        <path
          d="M36.2757 22.0005C36.2108 21.4819 35.8219 20.9744 35.1293 20.5806L29.6749 17.48L29.7767 17.3782H29.7771L35.1293 20.4211C35.8929 20.8555 36.2753 21.4279 36.2757 22.0005Z"
          fill="url(#paint9_linear_13536_276)"
        />
        <path
          d="M11.0182 9.89209C11.0182 9.89165 11.0182 9.89121 11.0182 9.89078C11.0182 9.89121 11.0182 9.89165 11.0182 9.89209ZM11.0229 9.71423C11.0229 9.71335 11.0229 9.71248 11.0229 9.7116C11.0229 9.71248 11.0229 9.71335 11.0229 9.71423ZM11.0232 9.70909C11.0232 9.70733 11.0232 9.70569 11.0232 9.70394C11.0232 9.70569 11.0232 9.70733 11.0232 9.70909ZM11.0232 9.70263C11.0866 8.57822 11.6976 7.92873 12.562 7.9249C12.1872 7.92709 11.8608 8.05022 11.6053 8.28062V8.28018L11.6022 8.28325C11.5753 8.30754 11.5497 8.33327 11.5244 8.35975C11.2373 8.6637 11.0561 9.11903 11.0232 9.70263Z"
          fill="#404040"
        />
        <path
          d="M11.0182 10.0581V9.89819C11.0182 9.89601 11.0182 9.89426 11.0182 9.89218C11.0182 9.89174 11.0182 9.8913 11.0182 9.89086C11.0182 9.83055 11.0198 9.77156 11.0229 9.71431C11.0229 9.71344 11.0229 9.71257 11.0229 9.71169C11.0229 9.71092 11.0229 9.71005 11.0232 9.70917C11.0232 9.70742 11.0232 9.70578 11.0232 9.70403C11.0232 9.70359 11.0232 9.70315 11.0232 9.70271C11.0561 9.11911 11.2373 8.66379 11.5244 8.35984L11.6044 8.44017C11.2373 8.7716 11.0182 9.32433 11.0182 10.0581ZM11.6022 8.28333L11.6053 8.28026C11.6044 8.28158 11.6031 8.28245 11.6022 8.28333Z"
          fill="url(#paint10_linear_13536_276)"
        />
        <path
          d="M29.6749 17.48L13.7977 8.45309C13.3575 8.20342 12.941 8.085 12.57 8.085C12.1919 8.085 11.862 8.20813 11.6044 8.44028L11.5244 8.35994C11.5497 8.33345 11.5753 8.30773 11.6022 8.28343C11.6031 8.28256 11.6044 8.28168 11.6053 8.28081C11.8608 8.05041 12.1872 7.92727 12.5619 7.92509C12.5628 7.92509 12.564 7.92509 12.5653 7.92509C12.5671 7.92509 12.5683 7.92509 12.57 7.92509C12.941 7.92509 13.3575 8.04351 13.7977 8.29328L29.7771 17.3779L29.7767 17.3782L29.6749 17.48Z"
          fill="url(#paint11_linear_13536_276)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_13536_276"
          x1="23.9554"
          y1="9.64236"
          x2="5.58655"
          y2="28.0002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.00657445" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13536_276"
          x1="37.1197"
          y1="22.0017"
          x2="10.6514"
          y2="22.0017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13536_276"
          x1="27.2668"
          y1="24.5132"
          x2="2.3572"
          y2="49.4078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_13536_276"
          x1="8.09164"
          y1="0.302413"
          x2="19.2148"
          y2="11.4188"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_13536_276"
          x1="37.1194"
          y1="22.002"
          x2="10.652"
          y2="22.002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCB300" />
          <stop offset="0.4087" stopColor="#CC9700" />
          <stop offset="0.7754" stopColor="#CC8400" />
          <stop offset="1" stopColor="#CC7D00" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_13536_276"
          x1="27.2668"
          y1="24.5132"
          x2="2.35719"
          y2="49.4078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CC2E36" />
          <stop offset="1" stopColor="#9C0E4E" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_13536_276"
          x1="23.9555"
          y1="9.64276"
          x2="5.5866"
          y2="28.0006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DE0" />
          <stop offset="0.00657445" stopColor="#008DE0" />
          <stop offset="0.2601" stopColor="#00A7E0" />
          <stop offset="0.5122" stopColor="#00B8E0" />
          <stop offset="0.7604" stopColor="#00C4E0" />
          <stop offset="1" stopColor="#00C7E0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_13536_276"
          x1="27.2673"
          y1="24.5137"
          x2="2.35832"
          y2="49.409"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0333C" />
          <stop offset="1" stopColor="#AB0F56" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_13536_276"
          x1="37.1197"
          y1="22.0017"
          x2="10.6514"
          y2="22.0017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0C500" />
          <stop offset="0.4087" stopColor="#E0A600" />
          <stop offset="0.7754" stopColor="#E09100" />
          <stop offset="1" stopColor="#E08900" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_13536_276"
          x1="37.1197"
          y1="22.0016"
          x2="10.6514"
          y2="22.0016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE840" />
          <stop offset="0.4087" stopColor="#FFCE40" />
          <stop offset="0.7754" stopColor="#FFBC40" />
          <stop offset="1" stopColor="#FFB540" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_13536_276"
          x1="23.9555"
          y1="9.6424"
          x2="5.58655"
          y2="28.0002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40B8FF" />
          <stop offset="0.00657445" stopColor="#40B9FF" />
          <stop offset="0.2601" stopColor="#40CEFF" />
          <stop offset="0.5122" stopColor="#40DDFF" />
          <stop offset="0.7604" stopColor="#40E7FF" />
          <stop offset="1" stopColor="#40EAFF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_13536_276"
          x1="8.09165"
          y1="0.302358"
          x2="19.2148"
          y2="11.4188"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#65B895" />
          <stop offset="0.0685" stopColor="#62BD95" />
          <stop offset="0.4762" stopColor="#50DB97" />
          <stop offset="0.8009" stopColor="#44ED98" />
          <stop offset="1" stopColor="#40F498" />
        </linearGradient>
        <clipPath id="clip0_13536_276">
          <rect width="148" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
